import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Eliminar',
  loading = false,
  onCancel,
  onConfirm
}: ConfirmDialogProps) {
  return <Modal open={open} onClose={onCancel} title={title} footer={<div className="flex justify-end gap-2" data-id="element-89" data-mp="2vbva49qkbo64">
          <Button variant="ghost" onClick={onCancel} disabled={loading} data-id="element-90" data-mp="2vbli6glyj6xs">
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} loading={loading} data-id="element-91" data-mp="2him8iv8uw6y5">
            {confirmLabel}
          </Button>
        </div>} data-id="element-88" data-mp="2rbtcqcrv1gwn">
      <p className="text-sm text-muted-foreground" data-id="element-92" data-mp="3a8uhbwhi5f02">{description}</p>
    </Modal>;
}